import { render, staticRenderFns } from "./WaitingEventTab.vue?vue&type=template&id=4f08a956&scoped=true&"
import script from "./WaitingEventTab.vue?vue&type=script&lang=js&"
export * from "./WaitingEventTab.vue?vue&type=script&lang=js&"
import style0 from "./WaitingEventTab.vue?vue&type=style&index=0&id=4f08a956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f08a956",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
